import React, { useEffect } from 'react';
import PageContainer from '../../../@jumbo/components/PageComponents/layouts/PageContainer';
import MaterialTable from '@material-table/core';
import axios_instance from '../../../services/auth/jwt/config';
import { Check, Close } from '@material-ui/icons';
import { tableIcons, tableLocalization } from '../../../@jumbo/constants/TableConstants';
import {
    FormControl,
    MenuItem,
    Paper,
    Select,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Button,
    TextField,
    Box,
    FormControlLabel,
    InputLabel,
    Chip
} from '@material-ui/core';

type StatusFilters = 'all' | 'active' | 'inactive';

type UserData = {
    id: number;
    user: {
        nome: string;
        cpf: string;
    };
    aprovado: boolean;
    reprovado: boolean;
    matricula: string;
}

interface UserAppProps {

}

export default function UserApp({ ...props }: UserAppProps) {
    const [filter, setFilter] = React.useState<StatusFilters>('all');
    const [aprovarDialog, setAprovarDialog] = React.useState<{ open: boolean, user: UserData | null }>({ open: false, user: null });
    const [reprovarDialog, setReprovarDialog] = React.useState<{ open: boolean, user: UserData | null }>({ open: false, user: null });
    const [observacao, setObservacao] = React.useState<string>('');
    const [loading, setLoading] = React.useState<boolean>(false);
    const tableRef = React.useRef<any>();

    useEffect(() => {
        tableRef.current?.onQueryChange();
    }, [filter]);

    const onAprovar = () => {
        if (!aprovarDialog.user) return;

        setLoading(true);
        axios_instance.post<{ success: boolean }>('prefeitura/matricula/aprovar', {
            id: aprovarDialog.user.id,
            observacao: observacao
        }).then(response => {

            if (response.data.success) {
                setAprovarDialog({ open: false, user: null });
                setObservacao('');
                tableRef.current?.onQueryChange();
            }
        }).catch(error => {
            console.error('Erro ao aprovar usuário:', error);
        }).finally(() => {
            setLoading(false);
        })
    }

    const onReprovar = () => {
        if (!reprovarDialog.user) return;

        setLoading(true);
        axios_instance.post<{ success: boolean }>('prefeitura/matricula/reprovar', {
            id: reprovarDialog.user.id,
            observacao: observacao
        }).then(response => {

            if (response.data.success) {
                setReprovarDialog({ open: false, user: null });
                setObservacao('');
                tableRef.current?.onQueryChange();
            }
        }).catch(error => {
            console.error('Erro ao reprovar usuário:', error);
        }).finally(() => {
            setLoading(false);
        })
    }

    const handleCloseAprovar = () => {
        setAprovarDialog({ open: false, user: null });
        setObservacao('');
    }

    const handleCloseReprovar = () => {
        setReprovarDialog({ open: false, user: null });
        setObservacao('');
    }

    // @ts-ignore
    return <PageContainer>
        <Paper>
            <Box p={2}>
                <FormControl variant="outlined" fullWidth>
                    <InputLabel>Status</InputLabel>
                    <Select
                        value={filter}
                        fullWidth
                        // @ts-ignore
                        onChange={(e) => setFilter(e.target.value)}
                        label="Status"
                    >
                        <MenuItem value="all">Todos</MenuItem>
                        <MenuItem value="active">Aprovados</MenuItem>
                        <MenuItem value="inactive">Reprovados</MenuItem>
                    </Select>
                </FormControl>
            </Box>
            <MaterialTable
                title="Usuários do App"
                tableRef={tableRef}
                columns={[
                    { title: 'Nome', field: 'user.nome' },
                    { title: 'CPF', field: 'user.cpf' },
                    { title: 'Matrícula', field: 'matricula' },
                    {
                        title: 'Status', field: 'aprovado', render: (rowData: UserData) => {
                            if (rowData.aprovado) {
                                return <Chip label="Aprovado" style={{ backgroundColor: '#4caf50', color: 'white' }} size="small" />;
                            } else if (rowData.reprovado) {
                                return <Chip label="Reprovado" style={{ backgroundColor: '#f44336', color: 'white' }} size="small" />;
                            } else {
                                return <Chip label="Pendente" style={{ backgroundColor: '#ff9800', color: 'white' }} size="small" />;
                            }
                        }
                    }
                ]}
                components={{
                    Container: props => <Paper {...props} elevation={0} />,
                }}
                data={(query: any) =>
                    new Promise<any>((resolve, reject) => {
                        let url = `prefeitura/matricula/list?status=${filter}`;
                        url += '&per_page=' + query.pageSize;
                        url += '&page=' + (query.page + 1);
                        if (query.orderBy) {
                            url += '&order_by=' + query.orderBy.field;
                            url += '&order=' + query.orderDirection;
                        }
                        if (query.search) {
                            url += '&search=' + query.search;
                        }
                        axios_instance.get<any>(url)
                            .then(response => {
                                let r = response.data;
                                if (r.success) {
                                    resolve({
                                        data: r.data.data,
                                        page: r.data.current_page - 1,
                                        totalCount: r.data.total,
                                    });
                                }
                            })
                            .catch(() => {
                                reject();
                            });
                    })}
                actions={[
                    {
                        icon: () => <Check />, tooltip: 'Aprovar', onClick: (_, rowData) => {
                            if (Array.isArray(rowData)) return;
                            setAprovarDialog({ open: true, user: rowData });
                        }
                    }, {
                        icon: () => <Close />, tooltip: 'Reprovar', onClick: (_, rowData) => {
                            if (Array.isArray(rowData)) return;
                            setReprovarDialog({ open: true, user: rowData });
                        }
                    }
                ]}
                localization={tableLocalization}
                icons={tableIcons}
                options={{
                    actionsColumnIndex: -1,
                }}
            />

            {/* Modal de Aprovação */}
            <Dialog
                open={aprovarDialog.open}
                onClose={handleCloseAprovar}
                maxWidth="sm"
                fullWidth
            >
                <DialogTitle>Aprovar Cadastro</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Deseja aprovar o cadastro de <strong>{aprovarDialog.user?.user.nome}</strong>?
                    </DialogContentText>
                    <TextField
                        autoFocus
                        margin="dense"
                        label="Observação (opcional)"
                        type="text"
                        fullWidth
                        multiline
                        minRows={3}
                        variant="outlined"
                        value={observacao}
                        onChange={(e) => setObservacao(e.target.value)}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseAprovar} color="default" disabled={loading}>
                        Cancelar
                    </Button>
                    <Button onClick={onAprovar} color="primary" variant="contained" disabled={loading}>
                        {loading ? 'Aprovando...' : 'Aprovar'}
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Modal de Reprovação */}
            <Dialog
                open={reprovarDialog.open}
                onClose={handleCloseReprovar}
                maxWidth="sm"
                fullWidth
            >
                <DialogTitle>Reprovar Cadastro</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Deseja reprovar o cadastro de <strong>{reprovarDialog.user?.user.nome}</strong>?
                    </DialogContentText>
                    <TextField
                        autoFocus
                        margin="dense"
                        label="Motivo da reprovação (opcional)"
                        type="text"
                        fullWidth
                        multiline
                        minRows={3}
                        variant="outlined"
                        value={observacao}
                        onChange={(e) => setObservacao(e.target.value)}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseReprovar} color="default" disabled={loading}>
                        Cancelar
                    </Button>
                    <Button onClick={onReprovar} color="secondary" variant="contained" disabled={loading}>
                        {loading ? 'Reprovando...' : 'Reprovar'}
                    </Button>
                </DialogActions>
            </Dialog>
        </Paper>
    </PageContainer >
}